// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getProductById } from 'app/constants/enums/Product/main';

/* eslint-disable max-len */
export const LIVE_LESSONS = getProductById('LiveLessons');
export const LIVE_LESSONS_NATIVE = getProductById('LiveLessonsNative');
export const STUDY_ABROAD = getProductById('StudyAbroad');
export const I_KNOW = getProductById('iKnow');
/* eslint-enable max-len */
